import { render } from "./Form25View.vue?vue&type=template&id=1bf736c6&scoped=true"
import script from "./Form25View.vue?vue&type=script&lang=js"
export * from "./Form25View.vue?vue&type=script&lang=js"

import "./Form25View.vue?vue&type=style&index=0&id=1bf736c6&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf736c6"]])

export default __exports__